import { forwardRef } from 'react';
import Select from 'react-select';
import { StateManagerProps } from 'react-select/dist/declarations/src/useStateManager';
import { getReadableColor } from '../../helpers';

const dot = (color = 'transparent') => ({
  alignItems: 'center',
  display: 'flex',

  ':before': {
    backgroundColor: color,
    content: '" "',
    display: 'block',
    marginRight: 8,
    height: 10,
    width: 10,
  },
});

const cutomStyle = {
  container: (base: any) => ({
    ...base,
    fontSize: '12px',
    height: '35px',
  }),
  control: (base: any) => ({
    ...base,
    height: '35px',
    minHeight: '35px',
    borderColor: '#d1d5db',
    alignItems: 'baseline',
  }),
  valueContainer: (base: any) => ({
    ...base,
    height: '33px',
    paddingTop: 0,
    paddingBottom: 0,
    overflow: 'auto',
  }),
  indicatorsContainer: (base: any) => ({
    ...base,
    height: '33px',
    overflow: 'hidden !important',
  }),
  input: (base: any) => ({
    ...base,
    height: '33px',
    // lineHeight: '33px',
    margin: 0,
    padding: 0,
  }),
  option: (styles: any, { data }: any) =>
    data.color
      ? {
          ...styles,
          ...dot(data.color),
        }
      : styles,
  singleValue: (styles: any, { data }: any) =>
    data.color
      ? {
          ...styles,
          ...dot(data.color),
        }
      : styles,
};

const RSelect = forwardRef(
  (
    props: StateManagerProps<any, any, any> &
      React.RefAttributes<any> & { max?: number },
    ref: any,
  ) => {
    return (
      <Select
        ref={ref}
        className='rSelect'
        menuPosition='fixed'
        placeholder=''
        {...props}
        options={
          !props.max || props.value?.length < props.max ? props.options : []
        }
        noOptionsMessage={
          props.max && props.value?.length >= props.max
            ? () => <>Maximum atteint</>
            : undefined
        }
        styles={{
          ...cutomStyle,
          ...props.styles,
          multiValueLabel: (styles, { data }) =>
            !data?.color
              ? styles
              : {
                  ...styles,
                  color: getReadableColor(data.color),
                },
          multiValue: (styles, { data }) =>
            !data?.color
              ? styles
              : {
                  ...styles,
                  backgroundColor: data.color,
                },
          multiValueRemove: (styles, { data }) =>
            !data?.color
              ? styles
              : {
                  ...styles,
                  color: getReadableColor(data.color),
                  ':hover': {
                    opacity: 0.5,
                  },
                },
        }}
        closeMenuOnSelect={!props.isMulti}
        isClearable={props.isClearable === false ? false : true}
      />
    );
  },
);

export default RSelect;
